export class EligibilityClient {
  constructor(eligibilityBackend, authenticationService) {
    this.eligibilityBackend = eligibilityBackend;
    this.authenticationService = authenticationService;
    this.BASE_URL = '/eligibility/v1.1';
  }

  /**
   * Consumo de endpoint para obtener políticas de elegibilidad a través del API GET /v1.0/eligibility/?country=CL&segment=SUBSIDY&classification=APPROVAL&type=current
   */

  async getEligibilitiesByAutomaticEvaluationId(evaluationId) {
    const response = await this.eligibilityBackend.get(`${this.BASE_URL}/eligibility?evaluationId=${evaluationId}`, {
      ...this.defaultAxiosRequestConfig()
    });
    return response.data;
  }

  defaultAxiosRequestConfig() {
    return {
      headers: this.authenticationService.authHeader()
    };
  }
}
